import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/client/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/assets/images/social-markup/default-social.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layouts/Application.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useStoryblokState"] */ "/app/node_modules/.pnpm/@storyblok+react@5.4.0_next@15.4.10_react-dom@18.3.1_react@18.3.1/node_modules/@storyblok/react/dist/core/use-storyblok-state.mjs");
